import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { isRatioValue, aspectForRatio } from "%/dynamic-component-editor/options/aspect-ratios";
import { useSelectedElementSizeStore } from "%/dynamic-component-editor/stores/selected-element-size-store";
import { formatSizeReadout } from "%/dynamic-component-editor/helpers/element-size-readout.mjs";

export default class LayoutWidth extends BaseOption {
  static defaultValue = "hug";
  static userInterfaceComponent = {
    label: "Width",
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      showAllResultsOnClick: true,
      items: [
        { value: "fill", label: "Fill" },
        { value: "hug", label: "Hug" },
        { value: "fixed", label: "Fixed", triggerCustom: true },
        { value: "ratio", label: "Ratio" },
      ],
      prefix: "W:",
      suffix: "px",
      itemValueKey: "value",
      itemLabelKey: "label",
      allowCustomValue: true,
      subtleValueVariants: ["auto", "fill", "hug"],
      placeholder: "Width",
      derivedValueComputed: (value, context) => {
        if (typeof value === "object") {
          value = value?.value;
        }
        if (value !== "fill" && value !== "hug") {
          return "";
        }
        const size = useSelectedElementSizeStore().sizeById[context.identifier];
        return size ? formatSizeReadout(size.width) : "";
      },
    },
  };

  static getCssValue(option) {
    if (isRatioValue(option)) {
      return "auto";
    }
    if (option === "fill") {
      return "100%";
    }
    if (option === "hug") {
      return "fit-content";
    }
    return option + "px";
  }

  static isRatio(option) {
    return isRatioValue(option);
  }

  static aspectFor(option) {
    return aspectForRatio(option);
  }
}
